export default {"src":"/_next/static/media/3.c0b51415.svg","height":78,"width":84,"blurWidth":0,"blurHeight":0};